import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-6 left-1/2 transform -translate-x-1/2 w-[90%] bg-white/80 backdrop-blur-md shadow-md rounded-xl z-50">
      <div className="flex justify-between items-center h-16 px-6">
        {/* Logo */}
        <div className="flex items-center space-x-2">
          <img src={logo} alt="Logo Clínica Corium" className="h-8" />
        </div>

        {/* Menú desktop */}
        <div className="space-x-6 hidden md:flex">
          <Link to="/" className="text-gray-700 hover:text-primary transition">Inicio</Link>
          <Link to="/servicios" className="text-gray-700 hover:text-primary transition">Servicios</Link>
          <Link to="#nosotros" className="text-gray-700 hover:text-primary transition">Nosotros</Link>
          <Link to="/contacto" className="text-gray-700 hover:text-primary transition">Contacto</Link>
        </div>

        {/* Botón móvil */}
        <div className="md:hidden">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="text-gray-700 text-2xl focus:outline-none"
          >
            ☰
          </button>
        </div>
      </div>

      {/* Menú desplegable móvil */}
      {isOpen && (
        <div className="md:hidden px-6 pb-4">
          <Link to="/" className="block py-2 text-gray-700 hover:text-primary" onClick={() => setIsOpen(false)}>Inicio</Link>
          <Link to="/servicios" className="block py-2 text-gray-700 hover:text-primary" onClick={() => setIsOpen(false)}>Servicios</Link>
          <Link to="#nosotros" className="block py-2 text-gray-700 hover:text-primary">Nosotros</Link>
          <Link to="/contacto" className="text-gray-700 hover:text-primary transition">Contacto</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
